export default "__VITE_ASSET__BgOgH1UR__"